module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isHcpView) ? _c('div', {
    attrs: {
      "id": "lesson-scroller"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "ls-header"
  }, [(_vm.$store.state.status.payment.paid) ? _c('div', {
    staticClass: "ls-header-text ellipsis"
  }, [(!_vm.isLoading && _vm.currentLessonObject) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.lessonScrollerWeekPrefix')))]) : _vm._e(), _vm._v(" "), _c('strong', [(_vm.currentLessonObject) ? _c('router-link', {
    attrs: {
      "to": 'lesson/' + _vm.currentLessonObject.permalink
    }
  }, [_c('span', {
    staticClass: "bold",
    domProps: {
      "textContent": _vm._s(!_vm.isLoading ? ' ' + _vm.currentLessonObject.week_name + ': ' + _vm.currentLessonObject.title : '')
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.isLoading ? _vm.$t('message.loadingText') : '')
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ls-header-nav"
  }, [_c('button', {
    staticClass: "ls-nav-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.isLeftLocked || _vm.isLoading
    },
    on: {
      "click": _vm.goLeft
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_left")])]), _vm._v(" "), _c('button', {
    staticClass: "ls-nav-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.isRightLocked || _vm.isLoading
    },
    on: {
      "click": _vm.goRight
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("chevron_right")])])])])]), _vm._v(" "), _c('div', {
    ref: "rail",
    staticClass: "ls-rail"
  }, [_vm._l((_vm.tiles), function(tile) {
    return [(tile.kind === 'loader') ? _c('div', {
      key: 'loader-' + tile.key,
      staticClass: "ls-tile dummyTile"
    }, [_vm._m(0, true)]) : (tile.kind === 'lesson') ? _c('div', {
      key: 'lesson-' + tile.key,
      staticClass: "ls-tile outerItem",
      class: {
        locked: tile.locked
      },
      attrs: {
        "data-lesson": tile.lessonNumber
      },
      on: {
        "click": function($event) {
          return _vm.goToPermalink(tile.data)
        }
      }
    }, [(tile.data.hasPersonalization) ? _c('span', {
      staticClass: "ls-chip ls-chip--personalized"
    }, [_vm._v(_vm._s(_vm.$t('message.labelPersonalized')))]) : _vm._e(), _vm._v(" "), _c('img', {
      attrs: {
        "src": tile.data.image_url,
        "alt": tile.data.title
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ls-titlebar"
    }, [_c('div', {
      staticClass: "ls-titles"
    }, [_c('div', {
      staticClass: "ls-title",
      domProps: {
        "textContent": _vm._s(tile.data.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ls-subtitle",
      domProps: {
        "textContent": _vm._s(tile.data.week_name.replace('Week', _vm.$t('message.labelWeek')))
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "ls-action",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v(_vm._s(tile.locked ? 'lock' : 'play_arrow'))])])])]) : _c('div', {
      key: 'bonus-' + tile.key,
      staticClass: "ls-tile innerItem",
      class: {
        locked: tile.locked
      },
      on: {
        "click": function($event) {
          return _vm.goToBonus(tile.data, tile.parent)
        }
      }
    }, [_c('span', {
      staticClass: "ls-chip ls-chip--bonus"
    }, [_vm._v(_vm._s(_vm.$t('message.labelBonus')))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": tile.data.image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ls-titlebar"
    }, [_c('div', {
      staticClass: "ls-titles"
    }, [_c('div', {
      staticClass: "ls-title",
      domProps: {
        "textContent": _vm._s(tile.data.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "ls-subtitle",
      domProps: {
        "textContent": _vm._s(tile.data.subTitle.replace('Week', _vm.$t('message.labelWeek')))
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "ls-action",
      attrs: {
        "type": "button"
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v(_vm._s(tile.locked ? 'lock' : 'play_arrow'))])])])])]
  })], 2)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ls-titlebar"
  }, [_c('div', {
    staticClass: "ls-titles"
  }, [_c('div', {
    staticClass: "ls-loader-bar wide"
  }), _vm._v(" "), _c('div', {
    staticClass: "ls-loader-bar"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ff725fc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/LessonInlineGrid/LessonInlineGrid.vue
// module id = 3807
// module chunks = 1